export const mediaBackgroundComponent = {
  key: 'mediaBackgroundComponent',
  name: 'Media Background Dept-Component',
  siteIdentifier: 'global',

  downloadLabel: 'Download the',
  videoLink: 'video',
  unsupportedVideoLabel: 'Unsupported video.',
};
